import React from 'react'
import { Link, useLocation } from 'react-router-dom'

export default function Confirmation() {
  const location = useLocation();

  return (
    <>
      <div key={location.state?.key} className='text-center mt-5'>
        <img src="./img/confirm.gif" style={{ mixBlendMode: "multiply" }} height={300} width={500} alt="" />
        <h4>Thank You For Order</h4>
        <h6 className='mb-4'>Your order has been successfully confirmed!!!</h6>
        <Link to="/order" className='btn btn-info'>Go Back Your Order</Link>
      </div>
    </>
  )
}
